<!-- 服务流程-展示块 -->
<template>
<div class="info-block">
  <router-link :to="{path: '#'}" class="info-block-a" v-if="info.order!=''">
    <div class="div-1" v-bind:style='{backgroundImage:info.imgUrl}'>
      <span>{{info.order}}</span>{{info.title}}
    </div>
    <div class="div-2">{{info.label.substring(0,80)}}</div>
    <div class="div-3">{{info.content.substring(0,80)}}</div>
  </router-link>
</div>
</template>

<script>
export default {
  name: 'JrfwInfo2',
  props: {
    info: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {

    }
  },
  created:function(){

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info-block .info-block-a{
  display: block;
  position:relative;
  box-sizing:content-box;
  height:140px;
  padding:10px 5px 10px 5px;
  margin:0px 0px 0px 0px;
  background-color: #FFF0CE;
  border:0px solid #ddd;
  background-size: 100px auto;
  background-repeat: no-repeat;
  background-position: 10px center;
  //box-shadow: #bbb 0px 0px 10px;
}

.info-block .info-block-a:hover{
  //border:1px solid var(--color6);
  //box-shadow:0px 0px 1px 0px var(--color6);
}

.div-1{
  position:relative;
  height:30px;
  width:100%;
  padding:0px 0px 0px 0px;
  font-size:16px;
  font-weight:600;
  text-align:left;
  line-height:30px;
  color:#000;
  //background:#fff;
  border:0px solid #ddd;
  background-size: 60px 60px;
  background-repeat: no-repeat;
  background-position: 0px center;
}

.div-1 span{
  position:relative;
  height:40px;
  width:40px;
  padding:0px 15px 0px 15px;
  font-size:16px;
  font-weight:600;
  text-align:left;
  line-height:40px;
  color:#000;
}

.div-2{
  position:relative;
  padding:2px 10px 0px 50px;
  font-size:12px;
  text-align:left;
  line-height:20px;
  color:#515151;
}

.div-3{
  position:relative;
  padding:10px 10px 0px 50px;
  font-size:12px;
  text-align:left;
  line-height:25px;
  color:#888888;
}


</style>



// WEBPACK FOOTER //
// src/components/module/ZzfwInfo2.vue